import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.400'),

		'@media (min-width: 48rem)': {
			gap: token('space.200'),
		},
	},
});

/**
 * __Image and text row container__
 *
 * Displays multiple `ImageAndTextRow`s in a single column.
 *
 * Use this to apply appropriate spacing between the rows.
 */
const ImageAndTextRowContainer = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	return <Box xcss={styles.root}>{children}</Box>;
};

export default ImageAndTextRowContainer;
